// src/utils/formatting.js
// Utility for formatting numbers with commas (used for beds, baths, size, lotSize)
const formatNumber = (num) => (num !== undefined && num !== null && num !== '' && !isNaN(num) ? Number(num).toLocaleString() : 'N/A');

/**
 * Formats a number to a fixed number of decimal places for use in form inputs.
 * Returns an empty string for invalid inputs.
 * @param {number|string} value - The value to format.
 * @param {number} decimalPlaces - The number of decimal places to format to.
 * @returns {string} The formatted number as a string, or an empty string.
 */
const formatNumberForInput = (value, decimalPlaces = 2) => {
  if (value === null || value === undefined || value === '') return '';
  const numericValue = Number(value);
  return !isNaN(numericValue) ? numericValue.toFixed(decimalPlaces) : '';
};

// Utility for formatting date
const formatDate = (dateStr, includeTime = false) => {
  if (!dateStr) return 'N/A';
  const date = new Date(dateStr);
  if (isNaN(date)) return 'N/A';
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const m = months[date.getMonth()];
  const d = date.getDate();
  const y = date.getFullYear();

  const datePart = `${m}-${d}-${y}`;

  if (includeTime) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${datePart} ${hours}:${minutes}`;
  }

  return datePart;
};

const formatRange = (min, max, formatter, suffix = '') => {
  const notAvailable = 'N/A';
  if ((min === null || min === undefined) && (max === null || max === undefined)) return notAvailable;
  const formattedMin = min !== null && min !== undefined ? formatter(min) : null;
  const formattedMax = max !== null && max !== undefined ? formatter(max) : null;

  if (formattedMin && formattedMax) {
    if (String(formattedMin) === String(formattedMax)) {
      return `<span dir="ltr">${formattedMin}</span>${suffix}`;
    }
    return `<span dir="ltr">${formattedMin} - ${formattedMax}</span>${suffix}`;
  }
  return formattedMin ? `<span dir="ltr">${formattedMin}</span>${suffix}` : formattedMax ? `<span dir="ltr">${formattedMax}</span>${suffix}` : notAvailable;
};

const currencyFormatter = (val) => {
  if (val === null || val === undefined) return '';
  const formatted = Math.round(Number(val || 0)).toLocaleString('en-US', {
    maximumFractionDigits: 0,
  });
  return `$${formatted}`;
};

const percentFormatter = (val) => `${Number(val || 0).toFixed(1)}%`;

const percentFormatterForSummary = (val) => `${Number(val || 0).toFixed(1)}%`;

export { formatNumber, formatDate, formatNumberForInput, formatRange, currencyFormatter, percentFormatter, percentFormatterForSummary };
